// Firebase config is selected at RUNTIME by hostname in src/app/env.ts (dev vs prod).
// Only the production flag lives here - never a project config (the old dev block was a trap).
export const environment = { production: true };
